import React, { useEffect, useState } from "react";
import axios from "axios";
import PostagemCard from "./PostagemCard";
import ShortsSection from "./ShortsSection";
import { PostagemDTO } from "../types";
import styles from "./styles/Feed.module.css";

const Feed: React.FC = () => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const [postagens, setPostagens] = useState<PostagemDTO[]>([]);
  const [pagina, setPagina] = useState(0);
  const [tamanho] = useState(10);
  const [carregando, setCarregando] = useState(false);

  const fetchFeed = async (paginaAtual: number) => {
    setCarregando(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get<PostagemDTO[]>(`${BASE_URL}/feed`, {
        params: { pagina: paginaAtual, tamanho },
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });

      if (paginaAtual === 0) {
        setPostagens(res.data);
      } else {
        setPostagens((prev) => [...prev, ...res.data]);
      }
    } catch (error) {
      console.error("Erro ao carregar feed:", error);
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => {
    fetchFeed(0);
  }, []);

  const handleCurtir = async (postagemId: number) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return alert("Você precisa estar logado para curtir.");

      await axios.post(
        `${BASE_URL}/postagens/${postagemId}/curtir`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setPostagens((prev) =>
        prev.map((p) =>
          p.id === postagemId
            ? {
                ...p,
                jaCurtiu: !p.jaCurtiu,
                totalCurtidas: p.jaCurtiu
                  ? p.totalCurtidas - 1
                  : p.totalCurtidas + 1,
              }
            : p
        )
      );
    } catch (error) {
      console.error("Erro ao curtir postagem:", error);
    }
  };

  const carregarMais = () => {
    const proximaPagina = pagina + 1;
    setPagina(proximaPagina);
    fetchFeed(proximaPagina);
  };

  // Renderiza o feed, inserindo ShortsSection depois da primeira postagem
  const renderFeed = () => {
    const elements: React.ReactNode[] = [];

    postagens.forEach((post, index) => {
      elements.push(
        <PostagemCard key={post.id} postagem={post} onCurtir={handleCurtir} />
      );

      // Insere a ShortsSection apenas após a primeira postagem
      if (index === 0) {
        elements.push(<ShortsSection key="shorts-after-first" />);
      }
    });

    return elements;
  };

  return (
    <div className={styles.feedContainer}>
      {renderFeed()}

      {carregando && (
        <div className={styles.loaderContainer}>
          <div className={styles.loader}></div>
        </div>
      )}

      {!carregando && postagens.length > 0 && (
        <div className={styles.buttonWrapper}>
          <button onClick={carregarMais} className={styles.loadMoreBtn}>
            Ver mais
          </button>
        </div>
      )}
    </div>
  );
};

export default Feed;